export const devicesTypes = {
    FETCH_REQUEST: "DEVICE_FETCH_REQUEST",
    FETCH_SUCCESS: "DEVICE_FETCH_SUCCESS",
    UPDATE_FILTERS: "DEVICE_UPDATE_FILTERS",
    UPDATE_UI: "DEVICE_UPDATE_UI",
    FETCH_FAILURE: "DEVICE_FETCH_FAILURE",
    DEVICE_COUNT_SUCCESS: "DEVICE_ALARM_COUNT_SUCCESS",
    DOWNLOAD_REQUEST: "DEVICE_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "DEVICE_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "DEVICE_DOWNLOAD_FAILURE",
    CLEAR_FILTER: "DEVICE_CLEAR_FILTER",
    CREATE_REQUEST: "DEVICE_CREATE_REQUEST",
    CREATE_SUCCESS: "DEVICE_CREATE_SUCCESS",
    CREATE_FAILURE: "DEVICE_CREATE_FAILURE",
    FETCH_DEVICE_TYPES_REQUEST: "DEVICE_FETCH_DEVICE_TYPES_REQUEST",
    FETCH_DEVICE_TYPES_SUCCESS: "DEVICE_FETCH_DEVICE_TYPES_SUCCESS",
    FETCH_DEVICE_TYPES_FAILURE: "DEVICE_FETCH_DEVICE_TYPES_FAILURE"
};

export const fetchRequest = (filter) => ({
    type: devicesTypes.FETCH_REQUEST,
    payload: filter
});

export const fetchSuccess = (resp) => ({
    type: devicesTypes.FETCH_SUCCESS,
    payload: resp
});
export const createRequest = () => ({
    type: devicesTypes.CREATE_REQUEST
});

export const createSuccess = (resp) => ({
    type: devicesTypes.CREATE_SUCCESS,
    payload: resp
});

export const createFailure = (error) => ({
    type: devicesTypes.CREATE_FAILURE,
    payload: error
});

export const updateFilters = (resp) => ({
    type: devicesTypes.UPDATE_FILTERS,
    payload: resp
});
export const updateUI = (payload) => ({
    type: devicesTypes.UPDATE_UI,
    payload: payload
});

export const devicesCountSuccess = (resp) => ({
    type: devicesTypes.DEVICE_COUNT_SUCCESS,
    payload: resp
});

export const fetchFailure = (resp) => ({
    type: devicesTypes.FETCH_FAILURE,
    payload: resp
});
export const fetchDeviceTypesRequest = () => ({
    type: devicesTypes.FETCH_DEVICE_TYPES_REQUEST
});

export const fetchDeviceTypesSuccess = (resp) => ({
    type: devicesTypes.FETCH_DEVICE_TYPES_SUCCESS,
    payload: resp
});

export const fetchDeviceTypesFailure = (resp) => ({
    type: devicesTypes.FETCH_DEVICE_TYPES_FAILURE,
    payload: resp
});

export const downloadRequest = (total, filters) => ({
    type: devicesTypes.DOWNLOAD_REQUEST,
    payload: total,
    filter: filters
});

export const downloadSuccess = (resp) => ({
    type: devicesTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: devicesTypes.DOWNLOAD_FAILURE,
    payload: error
});

export const clearFilter = () => ({
    type: devicesTypes.CLEAR_FILTER,
});